document.addEventListener("DOMContentLoaded", function () {
    const slider = document.querySelector(".testimonial-slider__swiper");
    if (!slider) return;

    const slides = slider.querySelectorAll(".swiper-slide");
    const nextBtn = document.querySelector(".testimonial-slider__nav--next");
    const prevBtn = document.querySelector(".testimonial-slider__nav--prev");

    // Function: update arrow visibility
    function updateArrows(swiper) {
        const perView = swiper.params.slidesPerView; // current breakpoint value
        const total = slides.length;

        if (total <= perView) {
            nextBtn?.classList.add("hidden");
            prevBtn?.classList.add("hidden");
        } else {
            nextBtn?.classList.remove("hidden");
            prevBtn?.classList.remove("hidden");
        }
    }

    const swiper = new Swiper(slider, {
        loop: false,
        slidesPerView: 1.37,
        spaceBetween: 9,
        watchOverflow: false, // we manage arrows manually
        navigation: {
            nextEl: ".testimonial-slider__nav--next",
            prevEl: ".testimonial-slider__nav--prev",
        },
        breakpoints: {
            525: { slidesPerView: 1.7, spaceBetween: 10 },
            600: { slidesPerView: 2.3, spaceBetween: 15 },
            890: { slidesPerView: 2.5, spaceBetween: 20 },
            1024: { slidesPerView: 3, spaceBetween: 21 },
        },

        // On init → check arrows
        on: {
            init() {
                updateArrows(this);
            },
            // On window resize / breakpoint change → update arrows
            breakpoint() {
                updateArrows(this);
            }
        }
    });
});
